//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
// Material ui Imports
// Custom components imports (and hooks and helpers)
import { v4 as uuid } from "uuid";

import { Vector3 } from "three";
import { EDragContentOptions } from "../models/hotspotDrag.models";
import { EHotspotType, IHotspot } from "../models/hotspot.models";
import { param } from "jquery";
// Media imports

//---------------------------------------------------------------------------------------------------
// ## MUI STYLED ##
// Layout stuff remains inline, other styling pulled into it's own components

//---------------------------------------------------------------------------------------------------
// ## INTERFACES ##

//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// Renders the different hotspots
export function blankHotspot(type: EDragContentOptions, params?: string): IHotspot {
    //-------------------------------------------------------------------------------------------------
    if (type === EDragContentOptions.INFORMATION) {
        // ## Declares ##
        return {
            id: uuid(),
            location: new Vector3(0, 0, 90),
            type: EHotspotType.INFORMATION,
            styles: {
                preClickStyles: {
                    // colours: { background: "#303030" },
                    hover: { scale: 1.2 },
                },
                postClickStyles: {
                    // colours: { background: "#303030" },
                },
            },
            contents: {
                preClickContent: {
                    icon: "info",
                    title: "Info Hotspot",
                },
                postClickContent: {
                    contentData: "Info content",
                },
            },
            actions: {
                closeable: true,
            },
        } as IHotspot;
    } else if (type === EDragContentOptions.MOVEMENT) {
        // ## Declares ##
        return {
            id: uuid(),
            location: new Vector3(90, -10, 0),
            type: EHotspotType.MOVEMENT,
            contents: {
                preClickContent: {
                    icon: "movement",
                },
            },
            actions: {
                movement: {
                    sceneId: "Scene Undefined",
                },
            },
        } as IHotspot;
    } else if (type === EDragContentOptions.INTERFACE) {
        // ## Declares ##
        return {
            id: uuid(),
            location: new Vector3(0, 0, 0),
            type: EHotspotType.INTERFACE,
            contents: {
                preClickContent: {
                    title: "New User Interface",
                    userInterface: [
                        {
                            sectionTitle: "New User Input",
                        },
                    ],
                },
            },
        } as IHotspot;
    } else if (type === EDragContentOptions.IMAGE) {
        // ## Declares ##
        return {
            id: uuid(),
            location: new Vector3(90, -10, 0),
            type: EHotspotType.INFORMATION,
            contents: {
                preClickContent: {
                    contentData: `<div class="rte-container"> <img src=${params} loading="lazy" style="object-fit: cover; border-radius: 5px; height: 200px; width: 200px; margin: 0px; position: relative;" draggable="true" id="I_50150" class="rte-image"> </div>`,
                },
            },
        } as IHotspot;
    } else if (type === EDragContentOptions.VIDEO) {
        // ## Declares ##
        return {
            id: uuid(),
            location: new Vector3(90, -10, 0),
            type: EHotspotType.INFORMATION,
            contents: {
                preClickContent: {
                    contentData: `<div class="rte-container"> <video id="${params}" width="400px" height="240" controls> <source src="${params}" type="video/mp4">Your browser does not support the video tag. </video> </div>`,
                },
            },
        } as IHotspot;
    } else if (type === EDragContentOptions.ANSWER) {
        // ## Declares ##
        if (params === "correct") {
            return {
                id: uuid(),
                location: new Vector3(-90, 0, 0),
                type: EHotspotType.ANSWER,
                styles: {
                    preClickStyles: { colours: { background: "#303030" } },
                    postClickStyles: { colours: { background: "#7ffc03" } },
                },
                contents: {
                    preClickContent: {
                        title: "Correct Answer Hotspot",
                    },
                    postClickContent: {
                        title: "Correct Answer Hotspot Feedback",
                    },
                },
                actions: {
                    appFeedback: {
                        proceed: true,
                        delay: 3,
                    },

                    closeable: false,
                },
            } as IHotspot;
        } else if (params === "incorrect") {
            return {
                id: uuid(),
                location: new Vector3(-90, 0, 0),
                type: EHotspotType.ANSWER,
                styles: {
                    preClickStyles: { colours: { background: "#303030" } },
                    postClickStyles: { colours: { background: "red" } },
                },
                contents: {
                    preClickContent: {
                        title: "Incorrect Answer Hotspot",
                    },
                    postClickContent: {
                        title: "Incorrect Answer Hotspot Feedback",
                    },
                },
                actions: {
                    closeable: false,
                },
            } as IHotspot;
        } else {
            return {
                id: uuid(),
                location: new Vector3(-90, 0, 0),
                type: EHotspotType.ANSWER,
                // styles: {
                //     preClickStyles: { colours: { background: "#303030" } },
                //     postClickStyles: { colours: { background: "#303030" } },
                // },
                contents: {
                    preClickContent: {
                        title: "Answer Hotspot",
                    },
                    postClickContent: {
                        title: "Answer Feedback",
                    },
                },
                actions: {
                    closeable: false,
                },
            } as IHotspot;
        }
    } else {
        // ## Declares ##
        return {
            id: uuid(),
            location: new Vector3(0, 0, -5),
            type: EHotspotType.INFORMATION,
            styles: {},
            contents: {
                preClickContent: {
                    title: "Hotspot",
                },
            },
            actions: {
                closeable: true,
            },
        } as IHotspot;
    }

    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
}

export function blankQuestionHotspot(time: number): IHotspot {
    //-------------------------------------------------------------------------------------------------
    // ## Declares ##
    const newHotspot: IHotspot = {
        id: uuid(),
        location: new Vector3(0, 0, 0),
        type: EHotspotType.QUESTION,
        contents: {
            preClickContent: {
                title: "",
                question: { time: time, answers: [] },
            },
        },
    } as IHotspot;

    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    return newHotspot;
}
